import { forwardRef } from 'react';
import clsx from 'clsx';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, className, id, ...rest }, ref) => {
    const inputId = id || `input-${label.replace(/\s+/g, '-').toLowerCase()}`;
    return (
      <div className="input-floating">
        <input
          ref={ref}
          id={inputId}
          placeholder=" "
          className={clsx(error && 'border-error', className)}
          aria-invalid={!!error}
          {...rest}
        />
        <label htmlFor={inputId}>{label}</label>
        {error && (
          <p className="mt-xs text-sm text-error">{error}</p>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';
